export default "__VITE_ASSET__Cmq9yF9h__"